import { createSlice } from '@reduxjs/toolkit'
import { IFacebookChatRoom } from '../../../app/types/facebook'
import { IPaginationResponse } from '../../../app/types/pagination'

export interface ChatMessagesProps {
  chatRooms: IPaginationResponse<IFacebookChatRoom>
  chatRoomMutate: () => void
}

const initialState: ChatMessagesProps = {
  chatRooms: {
    count: 0,
    page: 1,
    perPage: 10,
    records: [],
  },
  chatRoomMutate: () => {},
}

const facebookChatSlice = createSlice({
  name: 'facebookChat',
  initialState,
  reducers: {
    setChatRoomsMutate(state, { payload }) {
      return {
        ...state,
        chatRoomMutate: payload.mutate,
      }
    },
    setChatRooms: (state, { payload }) => {
      return {
        ...state,
        chatRooms: payload.chatRooms,
      }
    },
    updateChantRoomById: (state, { payload }) => {
      return {
        ...state,
        chatRooms: {
          ...state.chatRooms,
          records: state.chatRooms.records.map((chatRoom) => {
            if (chatRoom.objectId === payload.objectId) {
              return payload
            }
            return chatRoom
          }),
        },
      }
    },
    updateChatRoomsTags: (state, { payload }) => {
      state.chatRooms = {
        ...state.chatRooms,
        records: state.chatRooms.records.map((chatRoom) => {
          if (chatRoom.objectId === payload.objectId) {
            return {
              ...chatRoom,
              tags: payload.tags,
            }
          }
          return chatRoom
        }),
      }
      return state
    },
    updateChatRoomsAssingToUser: (state, { payload }) => {
      state.chatRooms = {
        ...state.chatRooms,
        records: state.chatRooms.records.map((chatRoom) => {
          if (chatRoom.objectId === payload.objectId) {
            return {
              ...chatRoom,
              assignToUser: payload.assignToUser,
            }
          }
          return chatRoom
        }),
      }
      return state
    },
  },
})

export const {
  setChatRooms,
  updateChatRoomsTags,
  updateChatRoomsAssingToUser,
  setChatRoomsMutate,
  updateChantRoomById,
} = facebookChatSlice.actions

export const chatRoomsState = (state: { facebookChat: ChatMessagesProps }) =>
  state.facebookChat?.chatRooms ?? initialState.chatRooms

export const chatRoomMutateState = (state: {
  facebookChat: ChatMessagesProps
}) => state.facebookChat?.chatRoomMutate ?? initialState.chatRoomMutate

export default facebookChatSlice.reducer
